<script>
  import tiposConta from '~js/tipos-conta';
  import tiposPessoaConta from '~js/tipos-pessoa-conta';
  import bancoServico from '~modulos/banco/servico';
  import agenciaServico from '~modulos/agencia/servico';
  
  export default {
    props: {
      dadosBancarios: {
        type: Array,
        required: true,
      },
    },
    data() {
      return {
        tiposConta: tiposConta,
        tiposPessoaConta: tiposPessoaConta,
        bancos: [],
        bancosAtivos: [],
        agencias: [],
        banco: '',
        agencia: '',
        conta: '',
        tipoConta: '',
        idInfoBancaria: 0,
        tipoPessoa: this.$storage.usuario().tipoPessoaFisicaJuridica,
      }
    },
    methods: {
      nomeTipoConta(tipo) {
        tipo = tipo !== -1 ? tipo : -1;
        if (tipo == -1) {
          return "---";
        } else {
          return this.tiposConta.find(tipoConta => {
            return tipoConta.id === tipo;
          }).nome;
        }
      },
      nomeTipoPessoaConta(tipoPessoa) {
        tipoPessoa = tipoPessoa ? tipoPessoa : 0;
        if (tipoPessoa == 0) {
          return "---";
        } else {
          return this.tiposPessoaConta.find(tipoPessoaConta => {
            return tipoPessoaConta.id === tipoPessoa;
          }).nome;
        }
      },
      nomeBanco(id) {
        return this.bancos.find(banco => {
          return banco.idBanco === id;
        }).nome;
      },
      numeroBanco(id) {
        return this.bancos.find(banco => {
          return banco.idBanco === id;
        }).numero;
      },
      idAgencia(numero) {
        return this.agencias.find(agencia => {
          return agencia.numero === numero;
        }).idAgencia;
      },
      carregarBancos() {
        return bancoServico.
          lista()
          .then(bancos => {
            this.bancos = bancos;
            this.bancosAtivos = bancos.filter(banco => banco.disponibilizarWEB);
          });
      },
      carregarAgencias() {
        this.agencias= [];
        
        if (this.banco === '') {
          return;
        }
        
        return agenciaServico.
          lista(this.banco)
          .then(agencias => {
            this.agencias = agencias;
          });
      },
      deletar(indice) {
        this.dadosBancarios.splice(indice, 1);
      },
      async editar(indice) {
        const dadoBancario = this.dadosBancarios[indice];
        this.dadosBancarios.splice(indice, 1);

        this.banco = dadoBancario.idBanco;
        await this.carregarAgencias();

        this.agencia = dadoBancario.numeroAgencia;
        this.conta = dadoBancario.numeroConta;
        this.tipoConta = dadoBancario.tipoConta;
        this.idInfoBancaria = dadoBancario.idInfoBancaria;
      },
      validar() {
        this.$validator
          .validateAll()
          .then(valido => {
            if (valido) {
              this.adicionar();
            }
          })
      },
      validarDadosNaoEnviados(){
        if(this.banco != '')
          return false;
        if(this.agencia != '')
          return false
        if(this.conta != '')
          return false;
        if(this.tipoConta != '')
          return false
        if(this.tipoPessoa != '' && this.tipoPessoa != null)
          return false;

        return true;
      },
      adicionar() {
        this.dadosBancarios.push({
          idInfoBancaria: this.idInfoBancaria,
          idBanco: this.banco,
          idAgencia: this.idAgencia(this.agencia),
          numeroBanco: this.numeroBanco(this.banco),
          numeroAgencia: this.agencia,
          numeroConta: this.conta,
          tipoConta: this.tipoConta, 
          tipoPessoa: this.tipoPessoa, 
        });

        this.idInfoBancaria = 0;
        this.banco = '';
        this.agencia = '';
        this.conta = '';
        this.tipoConta = '';
        this.tipoPessoa = '';
        this.agencias = [];

        this.$validator.reset();
      },
      arrayRemove(arr, value) {
        return arr.filter((el) => {
          return el.id != value;
        });
      },
    },
    mounted() {
      this.carregarBancos();
      this.tiposConta = this.arrayRemove(this.tiposConta, -1);
      this.tiposPessoaConta = this.arrayRemove(this.tiposPessoaConta, 0);
    },
  }
</script>

<template>
  <div>
    
    <div class="table-responsive">
      <table class="table table-hover table-pointer">
        <thead>
          <tr>
            <th>Banco</th>
            <th>Agência</th>
            <th>Número da conta</th>
            <th>Tipo de conta</th>
            <th>Tipo de pessoa</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(dadoBancario, indice) in dadosBancarios">
            <td>{{ nomeBanco(dadoBancario.idBanco) }} - {{ dadoBancario.numeroBanco }}</td>
            <td>{{ dadoBancario.numeroAgencia }}</td>
            <td>{{ dadoBancario.numeroConta }}</td>
            <td>{{ nomeTipoConta(dadoBancario.tipoConta) }}</td>
            <td>{{ nomeTipoPessoaConta(dadoBancario.tipoPessoa) }}</td>
            <td class="action">
              <button type="button"
                      class="btn btn-warning btn-xs"
                      @click="editar(indice)">
                <i class="fa fa-edit"></i>
              </button>
            </td>
            <td class="action">
              <button type="button"
                      class="btn btn-danger btn-xs"
                      @click="deletar(indice)">
                <i class="fa fa-trash"></i>
              </button>
            </td>
          </tr>
          <tr v-if="dadosBancarios.length === 0">
            <td colspan="5" class="text-center">Nenhum registro encontrado.</td>
          </tr>
        </tbody>
      </table>
    </div>
    
    <div class="row">
      <div class="col-lg-3">
        <div class="form-group required" :class="{'has-error': errors.has('banco')}">
          <label class="control-label" for="banco">Banco</label>

          <select class="form-control"
                  id="banco"
                  v-model="banco"
                  data-vv-name="banco"
                  data-vv-as="banco"
                  v-validate="'required'"
                  @change="carregarAgencias">
            <option value="">Selecione...</option>
            <option :value="banco.idBanco" v-for="banco in bancosAtivos">{{ banco.nome }}</option>
          </select>

          <p class="text-danger" v-show="errors.has('banco')">{{ errors.first('banco') }}</p>
        </div>
      </div>

      <div class="col-lg-3">
        <div class="form-group required" :class="{'has-error': errors.has('agencia')}">
          <label class="control-label" for="agencia">Agência</label>

          <select class="form-control"
                  id="agencia"
                  v-model="agencia"
                  data-vv-name="agencia"
                  data-vv-as="agencia"
                  v-validate="'required'">
            <option value="">Selecione...</option>
            <option :value="agencia.numero" v-for="agencia in agencias">{{ agencia.numero }}</option>
          </select>

          <p class="text-danger" v-show="errors.has('agencia')">{{ errors.first('agencia') }}</p>
        </div>
      </div>

      <div class="col-lg-2">
        <div class="form-group required" :class="{'has-error': errors.has('conta')}">
          <label class="control-label" for="conta">Número da conta</label>

          <input type="text"
                 class="form-control"
                 id="conta"
                 maxlength="20"
                 v-model="conta"
                 data-vv-name="conta"
                 data-vv-as="número da conta"
                 v-validate="'required'">

          <p class="text-danger" v-show="errors.has('conta')">{{ errors.first('conta') }}</p>
        </div>
      </div>

      <div class="col-lg-2">
        <div class="form-group required" :class="{'has-error': errors.has('tipoConta')}">
          <label class="control-label" for="tipo-conta">Tipo de conta</label>

          <select class="form-control"
                  id="tipo-conta"
                  v-model="tipoConta"
                  data-vv-name="tipoConta"
                  data-vv-as="tipo de conta"
                  v-validate="'required'">
            <option value="">Selecione...</option>
            <option :value="tipoConta.id" v-for="tipoConta in tiposConta">{{ tipoConta.nome }}</option>
          </select>

          <p class="text-danger" v-show="errors.has('tipoConta')">{{ errors.first('tipoConta') }}</p>
        </div>
      </div>

      <div class="col-lg-2">
        <div class="form-group" :class="{'has-error': errors.has('tipoPessoa')}">
          <label class="control-label" for="tipo-conta">Tipo de pessoa</label>

          <select class="form-control"
                  id="tipo-pessoa"
                  v-model="tipoPessoa"
                  data-vv-name="tipoPessoa"
                  data-vv-as="tipo de pessoa"
                  v-validate="">
            <option value="">Selecione...</option>
            <option :value="tipoPessoaConta.id" v-for="tipoPessoaConta in tiposPessoaConta">{{ tipoPessoaConta.nome }}</option>
          </select>

          <p class="text-danger" v-show="errors.has('tipoPessoa')">{{ errors.first('tipoPessoa') }}</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="form-group">
          <p class="text-danger">Atenção! A conta informada acima deve estar relacionada ao CPF ou CNPJ do cadastro.</p>
        </div>
      </div>
    </div>
    
    <div class="row">
      <div class="col-lg-12">
        <div class="form-group">
          <button
            type="button"
            class="btn btn-success"
            @click="validar">
            <i class="fa fa-plus"></i> Adicionar conta
          </button>
        </div>
      </div>
    </div>
    
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/fornecedor/componentes/compartilhado/FormDadosBancarios.vue